import { Col, Form, Label, Row } from "reactstrap"
import { UFDate, UFInput } from "../../../components/Common/Fields/Input"
import resetIcon from "../../../assets/icons/reset.svg"
import { useForm } from "react-hook-form"
import { useEffect } from "react"
import moment from "moment"
import { isEmpty } from "lodash"
import AccountsLi from "../../../components/Common/chooseFields/accountsLi"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import { useLocation, useNavigate } from "react-router-dom"
import LoadingButton from "../../../components/Common/LoadingButton"

const JournalEntryFilter = ({
  // handleSearchChange,
  handleDateChange,
  handleAccChange,
  initialLedger,
  initialDate,
}) => {
  const { control, watch, reset } = useForm()
  const navigate = useNavigate()
  const location = useLocation()
  const handleReset = () => {
    navigate(
      location?.pathname == "/finance-ledger-acc"
        ? "/finance-ledger-acc"
        : "/finance-account-book"
    )
    handleDateChange()
    // handleSearchChange()
    handleAccChange()
    reset({
      search: "",
      ledger_id: null,
    })
  }
  // useEffect(() => {
  //   handleSearchChange(watch("search"))
  // }, [watch("search")])

  useEffect(() => {
    if (initialLedger != null) {
      reset({ ledger_id: initialLedger || null, req_date: initialDate })
      // handleDataUpdate
    }
    // handleDataUpdate()
  }, [initialLedger, initialDate])

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : "" 
    //  reset({
    //   ...getValues(),
    //   req_date: data
    // });
    handleDateChange(fromDate, toDate)
  }

  const handleAccno = data => {
    // reset({
    //   ...getValues(),
    //   ledger_id: data || null,
    // })
    handleAccChange(data?.value)
    //    handleDatas({
    //     ...getValues(),
    //     ledger_id: data || null,
    //   })
    // }
    // const handleDataUpdate = () => {
    //   const dataValues = getValues()
    //   handleDatas(dataValues)
  }

  return (
    <>
      {/* Horizontal filter row */}
      <Form id="user-form" className="my-2 me-2 py-3">
        <Row className="align-items-end">
          <Col sm={2} className="mb-0">
            <FinanceLedgersLi
              control={control}
              placeholder="Select Ledger"
              name={"ledger_id"}
              target={"body"}
              onSelectChange={e => handleAccno(e)}
            />
            {/* <AccountsLi
              control={control}
              name={"account_code"}
              placeholder={"Code"}
              target={"body"}
              fromFilter={true}
            /> */}
          </Col>
          <Col sm={2} className="mb-0">
            <UFDate
              control={control}
              name={"req_date"}
              placeholder={"Date"}
              mode={"range"}
              onDateChange={e => handleRequestdate(e)}
            />
          </Col>
          <Col sm={2} className="mb-0">
            <div
              className="export-div pointer reset-img py-2"
              onClick={() => handleReset()}
            >
              <img src={resetIcon} height={15} width={15} className="me-2" /> Reset
            </div>
            {/* <LoadingButton
              form={`user-form`}
              color={"primary"}
              className="me-2"
              type="button"
              onClick={handleDataUpdate}
            >
              Update
            </LoadingButton> */}
          </Col>
        </Row>
        {/* If you want to add a search input horizontally, you can add another Col here */}
        {/* <Row className="mt-2">
          <Col sm={12}>
            <UFInput
              control={control}
              placeholder="Search"
              name={"search"}
              className={"search-input"}
            />
          </Col>
        </Row> */}
      </Form>

      {/* Previous vertical layout preserved for reference */}
      {/* <div className="d-flex justify-content-between align-items-center my-2 me-2 py-3">
        <Form id="user-form" className="">
          <Row className="mx-0">
            <Col sm={12} className="mb-2">
              <FinanceLedgersLi
                control={control}
                placeholder="select"
                name={"ledger_id"}
                target={"body"}
                onSelectChange={(e) => handleAccno(e)} 
              />
            </Col>
            <Col sm={12} className="mb-2">
              <UFDate
                control={control}
                name={"req_date"}
                placeholder={"Date"}
                mode={"range"}
                onDateChange={e => handleRequestdate(e)}
              />
            </Col>
          </Row>
          <div className="d-flex ">
            <div
              className="export-div pointer me-2 reset-img py-2 ms-auto"
              onClick={() => handleReset()}
            >
              <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
              Reset
            </div>
          </div>
        </Form>
      </div> */}
    </>
  )
}

export default JournalEntryFilter